import { render, staticRenderFns } from "./kr-select.vue?vue&type=template&id=6f5edb46&"
import script from "./kr-select.vue?vue&type=script&lang=js&"
export * from "./kr-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports